 <template>
    <div class="markettrends-dropdown">
        <mvtDropdownList
          :label="getSelectedItem.name"
          :items="getItems"
          @changed="change"
          textAlign="left"
        />
    </div>
</template>

<script src="./markettrends-dropdown.js"></script>

<style lang="scss">
@use "./markettrends-dropdown.scss" as *;
</style>